// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1vK56","description":"PatientConsentPreview_description__VdNSC"};